import { Typography, DialogContent } from "@mui/material";
import {
  BglDialog,
  BglDialogActions,
  BglDialogTitle,
} from "components/dialog/BglDialogStyles";
import { useGlobalConfig } from "context/GlobalContext";
import { useState } from "react";
import styles from "./EVLoadRefreshDialog.module.scss";
import { EVENT_MANAGEMENT_STRINGS } from "types/translations/EventManagementStrings";
import { BglCloseButton, BglPrimaryButton } from "components/button/BglButtons";
import { EV_LOAD_STRINGS } from "types/translations/EVLoadManagementStrings";

export interface EVLoadRefreshDialogProps {
  open: boolean;
  handleClose: () => void;
  handleRefresh: () => void;
  refreshCount: number;
}

export const EVLoadRefreshDialog = (props: EVLoadRefreshDialogProps) => {
  const { rc } = useGlobalConfig();
  const { translations } = rc;

  return (
    <BglDialog
      onClose={props.handleClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
    >
      <BglDialogTitle
        title={rc.utils.replaceTokens(
          translations.getTranslation(EV_LOAD_STRINGS.POPUP.TITLE),
          { refreshCount: props.refreshCount }
        )}
        onClose={props.handleClose}
      />

      <DialogContent>
        <Typography sx={{ margin: "10px 20px" }}>
          {translations.getTranslation(EV_LOAD_STRINGS.POPUP.MESSAGE)}
        </Typography>
      </DialogContent>

      <BglDialogActions>
        <div className={styles.btnCont}>
          <BglCloseButton
            sx={{ minWidth: "100px", backgroundColor: "green" }}
            onClick={props.handleRefresh}
          >
            {translations.getTranslation(EV_LOAD_STRINGS.POPUP.BTN.CONTINUE)}
          </BglCloseButton>

          <BglPrimaryButton
            sx={{ minWidth: "100px" }}
            onClick={props.handleClose}
          >
            {translations.getTranslation(EV_LOAD_STRINGS.POPUP.BTN.CANCEL)}
          </BglPrimaryButton>
        </div>
      </BglDialogActions>
    </BglDialog>
  );
};
